// Copied from photoData in @energiebespaarders/data-maps with a few tweaks for customer-facing labels
// Keep in sync with photoData in @energiebespaarders/data-maps as much as possible but not critical, can add as we go

export const photoLabels = [
  { label: 'Profielfoto woning', key: 'photo.profile' },
  { label: 'Energiejaarnota', key: 'photo.energyBill' },
  { label: 'Groepenkast', key: 'photo.fusebox' },
  { label: 'Huidige omvormer', key: 'photo.inverter' },
  { label: 'Gewenste locatie omvormer', key: 'photo.inverterLocation' },
  { label: 'Dakvlakken voor panelen', key: 'photo.roofSurfaces' },
  { label: 'Dagmaat dakpannen', key: 'photo.roofTilesSize' },
  { label: 'Isoleerbare gevels', key: 'photo.insulatableWalls' },
  { label: 'Ventilatieroosters', key: 'photo.ventilationGrille' },
  { label: 'Kruipluik en kruipruimte', key: 'photo.crawlspace' },
  { label: 'Hoogte kruipruimte foto', key: 'photo.crawlspaceHeight' },
  { label: 'Afmetingen kruipluik', key: 'photo.crawlspaceHatch' },
  { label: 'Leidingen in kruipruimte', key: 'photo.crawlspacePipework' },
  { label: 'Afval in kruipruimte', key: 'photo.crawlspaceRubbish' },
  { label: 'Obstakels in kruipruimte', key: 'photo.crawlspaceObstruction' },
  { label: 'Isoleerbare dakvlakken', key: 'photo.insulatableRoofSurfaces' },
  { label: 'Isoleerbare zoldervloer', key: 'photo.atticFloorInsulatableArea' },
  { label: 'Dakramen/dakkapellen in isolatiedeel', key: 'photo.roofWindowsInTargetArea' },
  { label: 'Locatie sedum', key: 'photo.sedumLocationScreenshot' },
  { label: 'Thermostaat', key: 'photo.thermostat' },
  { label: 'Verwarmingstype', key: 'photo.centralHeatingBoiler' },
  { label: 'Rookgasafvoer buiten', key: 'photo.boilerExhaust' },
  { label: 'Voorgestelde locatie buitenunit', key: 'photo.proposedHeatPumpLocationOuter' },
  {
    label: 'Voorgestelde locatie binnenunit',
    key: 'photo.proposedHeatPumpLocationInner',
  },
  { label: 'Warmteafgiftesystemen', key: 'photo.heatEmissionSystems' },
  {
    label: 'Verdeelstation van de vloerverwarming en de waterslangen',
    key: 'photo.floorHeatingHose',
  },
  { label: 'Vloer te voorzien van vloerverwarming', key: 'photo.underfloorHeatingOverview' },
  { label: 'Vloerverwarmingverdeler', key: 'photo.underfloorHeatingDistributor' },
  { label: 'Tekeningen CV en waterleidingen', key: 'photo.heatingWaterPipesDrawing' },
  { label: 'Ramen te vervangen', key: 'photo.windows' },
  { label: 'Kabeltraject laadpaal', key: 'photo.chargingBoxCableRoute' },
  { label: 'Kabeltraject thuisbatterij', key: 'photo.homeBatteryCableRoute' },
  { label: 'Spouwmuurisolatie bewijs', key: 'photo.wallInsulationEvidence' },
  { label: 'Vloerisolatie bewijs', key: 'photo.floorInsulationEvidence' },
  { label: 'Dakisolatie bewijs', key: 'photo.roofInsulationEvidence' },
  { label: 'Huidige zonnepanelen', key: 'photo.pvSystemEvidence' },
  { label: 'Kabeltraject', key: 'photo.pvCableRoute' },
  { label: 'Zonneboiler bewijs', key: 'photo.solarBoilerEvidence' },
  { label: 'Warmtapwatervoorziening bewijs', key: 'photo.hotWaterEvidence' },
  { label: 'Laadpaallocatie', key: 'photo.chargingBoxLocation' },
  { label: 'Locatie batterij', key: 'photo.homeBatteryLocation' },
  { label: 'Impregneerbare gevels', key: 'photo.impregnableWalls' },
  { label: 'Locatie buitenunit(s)', key: 'photo.airToAirHeatPumpOutsideUnitsLocation' },
  { label: 'Leidingtraject', key: 'photo.airToAirHeatPumpPiping' },
  { label: 'Ruimteoverzicht binnenunits', key: 'photo.airToAirHeatPumpIndoorUnitRooms' },
];
